import $ from 'jquery';

$(function() {

    initAgeCheck();

});


function initAgeCheck() {

    $('#age-check button').unbind('click');
    $('#age-check button').on('click', function() {

        if ($(this).hasClass('age-check-no')) {

            // Redirect to the drink aware site
            window.location.href = "https://www.drinkaware.co.uk/";

        } else if ($(this).hasClass('age-check-yes')) {

            axios.post('/age-verify', {
                verify: 'yes'
            })
                .then(function (response) {
                    console.log(response);
                })
                .catch(function (error) {
                    console.log(error);
                });

            // Close the popup and remove it
            $('#age-check').removeClass('show');
            setTimeout(function() {
                $('#age-check').remove();
            }, 1000);

        }

    });

}
